// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__aOSsm","value":"styles_value__fPzIs","overlaySection":"styles_overlaySection__4PWWF"};